import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import { TopLanesService } from '../../../interfaces/marketInsightsServiceInterfaces';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';

export const TOP_LANES_REQUEST = 'TOP_LANES_REQUEST';
export const TOP_LANES_SUCCESS = 'TOP_LANES_SUCCESS';
export const TOP_LANES_FAILURE = 'TOP_LANES_FAILURE';

const requestTopLanes = (): object => {
    return {
        type: TOP_LANES_REQUEST
    };
};

const receiveTopLanes = (json: object): object => {
    return {
        type: TOP_LANES_SUCCESS,
        payload: json
    };
};

const requestTopLanesFailed = (): object => {
    return {
        type: TOP_LANES_FAILURE
    };
};

export const fetchTopLanes = (query: any, topCount: number = 20): Function => {
    return async (dispatch: any): Promise<void> => {
        dispatch(requestTopLanes());

        const requestBody = {
            ...query,
            topCount
        };

        try {
            const json: TopLanesService = await ApiService.post(Endpoints.rankingArea2area, requestBody);

            if (Object.keys(json).length > 0) {
                dispatch(receiveTopLanes(json));
            } else {
                // If no top lanes are returned dispatch an empty object and handle it within the component
                dispatch(receiveTopLanes({}));
            }
        } catch (err) {
            dispatch(requestTopLanesFailed());
            dispatch(enqueueSnackbar({
                message: 'Error occurred while fetching top lanes.',
                variant: SnackbarMessageVariants.Error
            }));
        }
    };
};
